import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { deductionHeaderOptions } from '../../common/data';
import Tab from '../common/Tab';
import { useDispatch } from 'react-redux';

const HeaderStyled = styled.div`
  padding: 0 16px;
  display: flex;
  width: 100%; // 전체 너비 설정
  background-color: #fff;
  position: sticky;
  border-bottom: 1px solid var(--GrayScale-400);
  top: 64px;
  z-index: 99;

  .menuList {
    width: 100%; // 전체 너비 설정
    overflow-x: auto;
    gap: 20px;
    display: flex;
    align-items: center;
    white-space: nowrap; // 텍스트 줄바꿈 방지
    -ms-overflow-style: none; // IE, Edge 스크롤바 숨기기
    scrollbar-width: none; // Firefox 스크롤바 숨기기

    &::-webkit-scrollbar {
      display: none; // Chrome, Safari 스크롤바 숨기기
    }
  }
`;

//공제항목 헤더
const DeductionHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { t: tCommon } = useTranslation('common');
  const menuListRef = useRef(null);

  const menuList = deductionHeaderOptions(tCommon);

  const handleClick = path => {
    navigate(path);
  };

  useEffect(() => {
    if (
      pathname.includes('creditCards') ||
      pathname.includes('housingFunds') ||
      pathname.includes('otherDeductions')
    ) {
      if (menuListRef.current) {
        menuListRef.current.scrollTo({
          left: menuListRef.current.scrollWidth,
          behavior: 'smooth',
        });
      }
    }
  }, [pathname]);

  return (
    <HeaderStyled>
      <div className="menuList" ref={menuListRef}>
        {menuList.map((menu, index) => (
          <Tab
            label={menu.label}
            className="menu"
            selectedTab={menu.path === pathname}
            key={index}
            onClick={() => handleClick(menu.path)}
          />
        ))}
      </div>
    </HeaderStyled>
  );
};

export default DeductionHeader;
